import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import EResourceLink from '@bibliocommons/shared-eresource-link';

import './EResourceBlock.scss';

const EResourceBlock = ({ eResources, format }) => eResources.isEmpty() ? null : (
  <div className="cp-eresource-block well">
    <FormattedMessage id="bib_electronic_resources">{(heading) => <h4>{heading}</h4>}</FormattedMessage>
    <ul>
      {eResources.map((eResource) =>
        <li><EResourceLink eresourceDescription={eResource.get('description')} eresourceUrl={eResource.get('url')} format={format} /></li>
      )}
    </ul>
  </div>
);

EResourceBlock.propTypes = {
  eResources: ImmutablePropTypes.listOf(ImmutablePropTypes.mapContains({
    description: PropTypes.string,
    url: PropTypes.string.isRequired
  })),
  format: PropTypes.string
};

EResourceBlock.displayName = 'EResourceBlock';

export default EResourceBlock;



// WEBPACK FOOTER //
// ./app/components/shared/EResourceBlock/EResourceBlock.jsx